import { FiWifiOff } from 'react-icons/fi'

interface OfflineIndicatorProps {
  isOnline: boolean
}

const OfflineIndicator = ({ isOnline }: OfflineIndicatorProps): JSX.Element | null => {
  // Only show when offline
  if (isOnline) {
    return null
  }

  return (
    <div className="fixed top-4 left-4 bg-black bg-opacity-70 text-white rounded-lg px-3 py-2 text-sm z-[1000] flex items-center gap-2 shadow-lg">
      <FiWifiOff className="flex-shrink-0" />
      <span>Offline</span>
    </div>
  )
}

export default OfflineIndicator
